import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0.4rem 0 0 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  min-width: 110px;\n\n  button {\n    padding: 0.8rem 1rem;\n    background-color: ", ";\n    span {\n      font-weight: 400;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  // flex: 1;\n  margin-right: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 70% 20%;\n  margin: 0 0 30px 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var DiscountForm = styled.form(_templateObject());
export var Input = styled.div(_templateObject2(), function (props) {
  return props.theme.spacing.spacer;
});
export var InputWithButton = styled.div(_templateObject3());
export var InputWrapper = styled.div(_templateObject4());
export var ButtonWrapper = styled.div(_templateObject5(), function (props) {
  return props.theme.colors.primaryLight;
});
export var ChipsWrapper = styled.div(_templateObject6());